// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * NYCT-specific snapshot.
 */
export class NyctSnapshot implements flatbuffers.IUnpackableObject<NyctSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NyctSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNyctSnapshot(bb: flatbuffers.ByteBuffer, obj?: NyctSnapshot): NyctSnapshot {
    return (obj || new NyctSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNyctSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: NyctSnapshot,
  ): NyctSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NyctSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  batchSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  httpStatus(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  latencyMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  retryAttempt(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  droppedCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startNyctSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addBatchSize(builder: flatbuffers.Builder, batchSize: number) {
    builder.addFieldInt32(0, batchSize, 0);
  }

  static addHttpStatus(builder: flatbuffers.Builder, httpStatus: number) {
    builder.addFieldInt16(1, httpStatus, 0);
  }

  static addLatencyMs(builder: flatbuffers.Builder, latencyMs: number) {
    builder.addFieldInt32(2, latencyMs, 0);
  }

  static addRetryAttempt(builder: flatbuffers.Builder, retryAttempt: number) {
    builder.addFieldInt32(3, retryAttempt, 0);
  }

  static addDroppedCount(builder: flatbuffers.Builder, droppedCount: number) {
    builder.addFieldInt32(4, droppedCount, 0);
  }

  static endNyctSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNyctSnapshot(
    builder: flatbuffers.Builder,
    batchSize: number,
    httpStatus: number,
    latencyMs: number,
    retryAttempt: number,
    droppedCount: number,
  ): flatbuffers.Offset {
    NyctSnapshot.startNyctSnapshot(builder);
    NyctSnapshot.addBatchSize(builder, batchSize);
    NyctSnapshot.addHttpStatus(builder, httpStatus);
    NyctSnapshot.addLatencyMs(builder, latencyMs);
    NyctSnapshot.addRetryAttempt(builder, retryAttempt);
    NyctSnapshot.addDroppedCount(builder, droppedCount);
    return NyctSnapshot.endNyctSnapshot(builder);
  }

  unpack(): NyctSnapshotT {
    return new NyctSnapshotT(
      this.batchSize(),
      this.httpStatus(),
      this.latencyMs(),
      this.retryAttempt(),
      this.droppedCount(),
    );
  }

  unpackTo(_o: NyctSnapshotT): void {
    _o.batchSize = this.batchSize();
    _o.httpStatus = this.httpStatus();
    _o.latencyMs = this.latencyMs();
    _o.retryAttempt = this.retryAttempt();
    _o.droppedCount = this.droppedCount();
  }

  unpackFields(...fields: string[]): NyctSnapshotT {
    const t = new NyctSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("batch_size")) {
      t.batchSize = this.batchSize();
    }
    if (fieldSet.has("http_status")) {
      t.httpStatus = this.httpStatus();
    }
    if (fieldSet.has("latency_ms")) {
      t.latencyMs = this.latencyMs();
    }
    if (fieldSet.has("retry_attempt")) {
      t.retryAttempt = this.retryAttempt();
    }
    if (fieldSet.has("dropped_count")) {
      t.droppedCount = this.droppedCount();
    }
    return t;
  }
}

export class NyctSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public batchSize: number = 0,
    public httpStatus: number = 0,
    public latencyMs: number = 0,
    public retryAttempt: number = 0,
    public droppedCount: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NyctSnapshot.createNyctSnapshot(
      builder,
      this.batchSize,
      this.httpStatus,
      this.latencyMs,
      this.retryAttempt,
      this.droppedCount,
    );
  }

  clone(): NyctSnapshotT {
    const obj = new NyctSnapshotT();
    obj.batchSize = this.batchSize;
    obj.httpStatus = this.httpStatus;
    obj.latencyMs = this.latencyMs;
    obj.retryAttempt = this.retryAttempt;
    obj.droppedCount = this.droppedCount;
    return obj;
  }

  equals(other: NyctSnapshotT): boolean {
    if (this.batchSize !== other.batchSize) return false;
    if (this.httpStatus !== other.httpStatus) return false;
    if (this.latencyMs !== other.latencyMs) return false;
    if (this.retryAttempt !== other.retryAttempt) return false;
    if (this.droppedCount !== other.droppedCount) return false;
    return true;
  }
}

export function verifyNyctSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 2);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
  } finally {
    verifier.popDepth();
  }
}
